import $ from 'jquery'
import * as project from './functions'
import './polyfill'
import imageMapResize from 'image-map-resizer'

window.addEventListener('load', () => {
  imageMapResize()
  project.lazyLoad()
  project.smoothScroll()
  project.menuOverlay()
  project.setupModalVideo()
  project.setupAccordions()
  project.setupMapImages()
  project.setupTabProducts()
  project.animateNumbers()

  if ($('.slider-init').length > 0) {
    $('.slider-init').each(function() {
      project.setupSlideshow($(this), $(this).data('slick'), $(this).data('slides'))
    })
  }

  const bodyClasses = $('body').attr("class").split(/\s+/)
  
  $.each(bodyClasses, function(key, value) {
    switch(value) {
      case "home":
        break
      case "single-product":
        project.productArrowColor()
        break
      default:
        $('#loader').fadeOut(500)
    }
  })
})